import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex rounded-lg gap-x-4" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "text-14px font-normal text-gray-lp-800" }
const _hoisted_4 = { class: "ml-4 text-14px font-semibold text-black-lp-100" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  style: {"width":"1px","background":"#D4D5D8"},
  class: "h-auto"
}, null, -1)
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "text-14px font-normal text-gray-lp-800" }
const _hoisted_8 = { class: "ml-4 text-14px font-semibold text-black-lp-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("dispatch.totalSttKoliShort")), 1),
      _createVNode("p", _hoisted_4, _toDisplayString(_ctx.totalStt) + "/" + _toDisplayString(_ctx.totalPieces), 1)
    ]),
    _hoisted_5,
    _createVNode("div", _hoisted_6, [
      _createVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("dispatch.weight")), 1),
      _createVNode("p", _hoisted_8, _toDisplayString(_ctx.totalWeight) + " kg ", 1)
    ])
  ]))
}